<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :tableData="tableData"
              :isSearch="isSearch"
              @add="add"
              @pageNumChange="pageNumChange"
              @keyup.enter.native="keyup()">
      <div slot="table">
        <label-table :tableData="tableData.list" @update="update" @del="del"></label-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import LabelTable from "./VersionTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getVersionInfoList,newVue,delByVersionInfoId} from "../../network/version";

  export default {
    name: "LabelList",
    components: {LabelTable, MyTable},
    data(){
      return {
        title: "版本信息列表",
        isAdd:true,
        tableData:{},
        isSearch: false,
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo = {
        href: "/version/list",
        name: "版本信息管理"
      };
      this.common.HeaderLocationTwo.href = "/version/list";
      this.common.HeaderLocationTwo.name = "版本信息管理";
      this.common.HeaderLocationThree.name = "版本信息列表"
      getVersionInfoList().then(res => {
        this.tableData = res.data
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        // let labelName = null;
        // for (let i = 0;i<searchItems.length;i++){
        //   if (searchItems[i].value === "labelName") {
        //     labelName = searchItems[i].input
        //   }
        // }
        getVersionInfoList(pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      add(){
        this.$router.push("insert/")
      },
      update(id){
        this.$router.push("insert/"+id)
      },
      del(id){
        this.$confirm('此操作会将该版本信息永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delByVersionInfoId(id).then(res => {
              if (res.code == 200) {
                this.searchEasy(this.searchItems);
              }
            }
          )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  }
</script>

<style scoped>

</style>
